import {
  ApiResponse,
  AuditLogListResponse,
  FinAPIConnection,
  SavingsPlanStaffListResponse,
} from '@mygate/common';
import { api } from './api';

interface ListConnectionsResponse {
  items: FinAPIConnection[];
  total: number;
}

interface SparplanListParams {
  userId?: string;
  status?: string;
  limit?: number;
  skip?: number;
}

interface ListParams {
  userId?: string;
  status?: string;
  limit?: number;
  skip?: number;
}

interface AuditLogParams {
  userId?: string;
  action?: string;
  resourceType?: string;
  outcome?: string;
  from?: string;
  to?: string;
  limit?: number;
  skip?: number;
}

const buildQuery = (params: Record<string, unknown>): string => {
  const pairs: string[] = [];
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '') continue;
    pairs.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  }
  return pairs.length === 0 ? '' : `?${pairs.join('&')}`;
};

/**
 * Backoffice client for finAPI oversight endpoints (staff-only).
 *
 * The backoffice `api.get` does not accept query params, so we
 * build the query string inline here. Each public method returns the
 * standard `ApiResponse<T>` envelope.
 */
class FinAPIStaffService {
  async listConnections(params: ListParams = {}): Promise<ApiResponse<ListConnectionsResponse>> {
    return api.get(`/api/staff/finapi/connections${buildQuery(params as Record<string, unknown>)}`);
  }

  async listAuditLog(params: AuditLogParams = {}): Promise<ApiResponse<AuditLogListResponse>> {
    return api.get(`/api/staff/finapi/audit-log${buildQuery(params as Record<string, unknown>)}`);
  }

  async forceRevokeConnection(connectionId: string): Promise<ApiResponse<{ revoked: true }>> {
    return api.post(`/api/staff/finapi/connections/${encodeURIComponent(connectionId)}/force-revoke`);
  }

  async listSavingsPlans(
    params: SparplanListParams = {},
  ): Promise<ApiResponse<SavingsPlanStaffListResponse>> {
    return api.get(`/api/staff/finapi/sparplans${buildQuery(params as Record<string, unknown>)}`);
  }
}

export const finapiStaffService = new FinAPIStaffService();
